import React from "react";

const BRANDS = [
  "OpenAI",
  "Gamma",
  "Gemini",
  "Perplexity",
  "Napkin AI",
  "Scaler",
  "Revolo",
  "ElevenLabs",
  "OpenArt",
  "Higgsfield",
  "IIT",
  "BITS Pilani",
  "IIM",
  "UtopAI",
  "AMD",
  "Samsung",
  "Vivo",
  "Lemonn",
  "Sahi",
  "Outskill",
];

// Split brands into 3 roughly equal groups
function chunk(arr, parts) {
  const size = Math.ceil(arr.length / parts);
  const out = [];
  for (let i = 0; i < parts; i++) {
    out.push(arr.slice(i * size, (i + 1) * size));
  }
  return out;
}

function Row({ items, direction = "left", speed = 28 }) {
  // 2x loop to seamlessly match the -50% keyframe endpoint
  const loop = [...items, ...items];
  return (
    <div className="relative overflow-hidden">
      <div
        className="marquee-track"
        style={{
          animationDuration: `${speed}s`,
          animationDirection: direction === "right" ? "reverse" : "normal",
        }}
      >
        {loop.map((brand, i) => (
          <div
            key={`${brand}-${i}`}
            className="shrink-0 text-white/45 hover:text-white/85 transition-colors font-semibold tracking-wide text-sm md:text-base whitespace-nowrap"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            {brand}
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * variant:
 *  - "single"  : original single-row (used at the bottom of hero or full-width contexts)
 *  - "stacked" : 3 rows in alternating directions (fills vertical space in narrower columns)
 */
export default function BrandsMarquee({ variant = "single" }) {
  if (variant === "stacked") {
    const rows = chunk(BRANDS, 3);
    return (
      <div className="relative rounded-2xl border border-[rgba(196,255,61,0.18)] bg-[#0e1410]/60 backdrop-blur px-2 py-5 md:py-6 overflow-hidden">
        <p className="text-center text-[10px] md:text-[11px] uppercase tracking-[0.3em] text-white/45 mb-4">
          Growth Partner Behind World&apos;s Leading Brands
        </p>

        {/* fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-12 md:w-16 bg-gradient-to-r from-[#0e1410] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-12 md:w-16 bg-gradient-to-l from-[#0e1410] to-transparent z-10" />

        <div className="space-y-3.5 md:space-y-4">
          <Row items={rows[0]} direction="left" speed={26} />
          <Row items={rows[1]} direction="right" speed={32} />
          <Row items={rows[2]} direction="left" speed={30} />
        </div>
      </div>
    );
  }

  // Single row (default)
  return (
    <div className="mt-6 relative overflow-hidden">
      <p className="text-center text-[10px] md:text-xs uppercase tracking-[0.28em] text-white/40 mb-4">
        Growth Partner Behind World&apos;s Leading Brands
      </p>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 bg-gradient-to-r from-[#0a0f0a] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 bg-gradient-to-l from-[#0a0f0a] to-transparent z-10" />
      <Row items={BRANDS} direction="left" speed={28} />
    </div>
  );
}
